import React from "react";
import styled from "styled-components";
import SideBar from "../nav/Sidebar";

interface PageProps {
  children: React.ReactNode;
  className?: string;
  color?: string;
}

const Container = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: left;
  gap: 20px;
  margin: 0px auto;

  padding-top: 20px;
  padding-left: 260px;
  padding-right: 20px;
  @media (max-width: 1450px) {
    padding-left: 80px;
  }
  box-sizing: border-box;
`;

const PageContainer: React.FC<PageProps> = ({ children }) => {
  return <Container>{children}</Container>;
};

export default PageContainer;
